import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Import Images
import bg1 from '../../images/background/line-bg1.png';
import ptImg1 from '../../images/shap/circle-orange.png';
import ptImg2 from '../../images/shap/plus-orange.png';
import ptImg3 from '../../images/shap/circle-dots.png';
import Img1 from '../../images/01.png';
import Img2 from '../../images/02.png';
import Img3 from '../../images/03.png';

class aboutSection extends Component{
	render(){
		return(
			<>
				
				<section className="section-area section-sp5 work-area" style={{backgroundImage: "url("+bg1+")", backgroundRepeat:" no-repeat", backgroundPosition: "center", backgroundSize: "100%"}}>
					<div className="container-sm">
						<div className="heading-bx text-center">
							<h6 className="title-ext text-secondary">Working Progress</h6>
							<h2 className="title text-capitalize">Our Working Process</h2>
						</div>
						<div className="row justify-content-center">
							<div className="col-lg-4 col-sm-6 mb-30">
								<div className="work-bx">
									<div className="work-shape"></div>
									<img src={Img1} alt="01" className='mb-30' style={{width:"80px"}}/>
									<div className="work-content">
										<h5 className="title text-primary mb-10">Book Appointmnet</h5>
										<p>Call us or book online. Quick, simple, and hassle-free scheduling.</p>
									</div>
									<Link to="/booking" className="btn btn-primary" style={{fontSize:"16px"}}>View More <i className="fas fa-arrow-right" style={{fontSize:"12px"}}></i></Link>
								</div>
							</div>
							<div className="col-lg-4 col-sm-6 mb-30">
								<div className="work-bx work-bx2 active">
									<div className="work-shape"></div>
									<img src={Img2} alt="02" className='mb-30' style={{width:"80px"}}/>
									<div className="work-content">
										<h5 className="title text-primary mb-10">Meet Our Doctors</h5>
										<p>Get expert consultation and accurate diagnosis — all in one visit.</p>
									</div>
									<Link to="/services" className="btn btn-white" style={{fontSize:"16px"}}>View More <i className="fas fa-arrow-right" style={{fontSize:"12px"}}></i></Link>
								</div>
							</div>
							<div className="col-lg-4 col-sm-6 mb-30">
								<div className="work-bx">
									<div className="work-shape"></div>
									<img src={Img3} alt="03" className='mb-30' style={{width:"80px"}}/>
									<div className="work-content">
										<h5 className="title text-primary mb-10">Start Treatment</h5>
										<p>We create a personalized care plan and guide you every step of the way.</p>
									</div>
									<Link to="/contact-us" className="btn btn-primary" style={{fontSize:"16px"}}>View More <i className="fas fa-arrow-right" style={{fontSize:"12px"}}></i></Link>
								</div>
							</div>
						</div>
					</div>
					<img className="pt-img1 animate1" src={ptImg1} alt=""/>
					<img className="pt-img2 animate2" src={ptImg2} alt=""/>
					<img className="pt-img3 animate3" src={ptImg3} alt=""/>
				</section>
				
			</>
		);
	}
}

export default aboutSection;